import { useEffect } from 'react';

const TOOLTIP_MAX_DURATION = 5000;

const useGlobalTooltips = () => {
  useEffect(() => {
    let tooltipEl = null;
    let currentTarget = null;
    let showTimeout = null;
    let maxDurationTimeout = null;

    const showTooltip = (el) => {
      hideTooltip();
      const text = el.getAttribute('data-tt');
      if (!text) return;

      tooltipEl = document.createElement('div');
      tooltipEl.className = 'custom-tooltip';
      tooltipEl.style.visibility = 'hidden';

      const lines = text.split('\n');
      lines.forEach((line, i) => {
        const div = document.createElement('div');
        div.className = `custom-tooltip-line custom-tooltip-line--${i + 1}`;
        div.textContent = line;
        tooltipEl.appendChild(div);
      });

      document.body.appendChild(tooltipEl);

      const rect = el.getBoundingClientRect();
      const tipRect = tooltipEl.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      if (spaceBelow < tipRect.height + 16) {
        tooltipEl.style.top = `${rect.top - tipRect.height - 4}px`;
      } else {
        tooltipEl.style.top = `${rect.bottom + 4}px`;
      }
      let left = rect.left + rect.width / 2 - tipRect.width / 2;
      left = Math.max(4, Math.min(left, window.innerWidth - tipRect.width - 4));
      tooltipEl.style.left = `${left}px`;
      tooltipEl.style.visibility = '';

      currentTarget = el;
      el.addEventListener('mouseleave', hideTooltip);

      maxDurationTimeout = setTimeout(() => {
        hideTooltip();
      }, TOOLTIP_MAX_DURATION);
    };

    const hideTooltip = () => {
      if (showTimeout) {
        clearTimeout(showTimeout);
        showTimeout = null;
      }
      if (maxDurationTimeout) {
        clearTimeout(maxDurationTimeout);
        maxDurationTimeout = null;
      }
      if (tooltipEl) {
        tooltipEl.remove();
        tooltipEl = null;
      }
      if (currentTarget) {
        currentTarget.removeEventListener('mouseleave', hideTooltip);
        currentTarget = null;
      }
    };

    const handleMouseOver = (e) => {
      const el = e.target.closest('[data-tt]');
      if (!el) return;
      clearTimeout(showTimeout);
      showTimeout = setTimeout(() => {
        if (!el.matches(':hover')) return;
        showTooltip(el);
      }, 200);
    };

    const handleScroll = () => hideTooltip();

    document.addEventListener('mouseover', handleMouseOver, true);
    document.addEventListener('scroll', handleScroll, true);
    return () => {
      document.removeEventListener('mouseover', handleMouseOver, true);
      document.removeEventListener('scroll', handleScroll, true);
      hideTooltip();
    };
  }, []);
};

export default useGlobalTooltips;
